module.exports = __webpack_public_path__ + "img/freecharge.ba0bac7a.png";